import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import ImageUpload from "@/components/ImageUpload";
import { Loader2, Building2, Save } from "lucide-react";
import { toast } from "sonner";

const FIELDS = [
  ["nome_fantasia", "Nome fantasia"],
  ["razao_social", "Razão social"],
  ["cnpj", "CNPJ"],
  ["endereco", "Endereço"],
  ["telefone", "Telefone"],
  ["email", "E-mail"],
];

export default function ConfigEmpresa() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/config/empresa").then((r) => setForm(r.data)); }, []);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/config/empresa", {
        nome_fantasia: form.nome_fantasia, razao_social: form.razao_social, cnpj: form.cnpj,
        endereco: form.endereco, telefone: form.telefone, email: form.email, logo_path: form.logo_path || null,
      });
      setForm(data);
      toast.success("Dados da empresa salvos");
    } catch (e) { toast.error(e.response?.data?.detail || "Erro ao salvar"); }
    finally { setSaving(false); }
  };

  if (!form) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;

  return (
    <div className="space-y-5 max-w-2xl" data-testid="config-empresa-page">
      <div>
        <div className="text-xs text-primary uppercase tracking-[0.18em] font-bold">Configurações</div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold uppercase flex items-center gap-2"><Building2 className="w-7 h-7 text-primary" /> Empresa</h1>
        <p className="text-sm text-muted-foreground mt-1">Estes dados e a logo são usados automaticamente nos relatórios em PDF desta empresa.</p>
      </div>

      <Card className="bg-card/70 p-5 space-y-4">
        <div>
          <Label>Logo da empresa</Label>
          <p className="text-xs text-muted-foreground mb-2">Aparece no topo dos PDFs. Sem logo, usamos a logo padrão do NEXO LOG.</p>
          <ImageUpload value={form.logo_path || ""} onChange={(path) => set("logo_path", path)} label="" testid="empresa-logo" />
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          {FIELDS.map(([k, label]) => (
            <div key={k} className={k === "endereco" ? "sm:col-span-2" : ""}>
              <Label>{label}</Label>
              <Input value={form[k] || ""} onChange={(e) => set(k, e.target.value)} data-testid={`empresa-${k}`} />
            </div>
          ))}
        </div>
        <Button onClick={save} disabled={saving} data-testid="btn-salvar-empresa">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Salvar
        </Button>
      </Card>
    </div>
  );
}
